import { getApps, initializeApp, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getRemoteConfig, getBoolean, getNumber, getString } from 'firebase/remote-config';
export { fetchAndActivate } from 'firebase/remote-config';
import { IS_PROD_ENV } from './const.js';

const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
};
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);
let remoteConfig = null;
// Only load Remote Config on the client
if (typeof window !== "undefined") {
    remoteConfig = getRemoteConfig(app);
    remoteConfig.settings = {
        minimumFetchIntervalMillis: 300000
    };
    remoteConfig.defaultConfig = {
        welcome_message: "Hello!"
    };
}
function readRemoteConfigValue(config, _keyName, format, fallback) {
    var _a, _b, _c;
    const keyName = IS_PROD_ENV ? _keyName : `test_${_keyName}`;
    if (!config)
        return fallback;
    try {
        switch (format) {
            case "json": {
                const raw = getString(config, keyName);
                return (raw ? JSON.parse(raw) : fallback);
            }
            case "string":
                return ((_a = getString(config, keyName)) !== null && _a !== void 0 ? _a : fallback);
            case "number":
                return ((_b = getNumber(config, keyName)) !== null && _b !== void 0 ? _b : fallback);
            case "bool":
                return ((_c = getBoolean(config, keyName)) !== null && _c !== void 0 ? _c : fallback);
            default:
                return fallback;
        }
    }
    catch (err) {
        console.warn(`Failed to read remote config value for key "${keyName}"`, err);
        return fallback;
    }
}

export { db, readRemoteConfigValue, remoteConfig };
//# sourceMappingURL=firebase.service.js.map
